import { Application } from "@hotwired/stimulus"
import PageToolsController from "./controllers/page_tools_controller"

const application = Application.start()
application.register("page-tools", PageToolsController)
